import { debounce } from '@fe/core';
import { ProductsChangedEventTypes, SelectedWeatherItem } from '@fe/weather';
import React from 'react';
import useWeatherService from '../../hooks/use-weather-service';

export default function useSelectedWeather(options?: { ignoreEvents?: ProductsChangedEventTypes[] }) {
    const weatherService = useWeatherService();

    const [selectedProducts, setSelectedProducts] = React.useState<SelectedWeatherItem[]>(
        () => weatherService?.getSelectedProducts() ?? []
    );

    const debounceSelectedProducts = React.useCallback(debounce<[SelectedWeatherItem[]]>(setSelectedProducts, 25), []);

    React.useEffect(() => {
        if (!weatherService) {
            return;
        }
        setSelectedProducts(weatherService.getSelectedProducts());
        return weatherService.on('products.changed', (e) => {
            if (options?.ignoreEvents?.includes(e.kind)) {
                return;
            }
            debounceSelectedProducts(weatherService.getSelectedProducts());
        }).unsubscribe;
    }, [weatherService, ...(options?.ignoreEvents ?? [])]);

    return selectedProducts;
}
